import { useState } from "react";

type UseDisclose = (initState?: boolean) => {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
};

export const useDisclose: UseDisclose = (initState) => {
  const [isOpen, setIsOpen] = useState(initState ?? false);
  const onOpen = (): void => setIsOpen(true);
  const onClose = (): void => setIsOpen(false);
  const onToggle = (): void => setIsOpen(!isOpen);

  return { isOpen, onOpen, onClose, onToggle };
};
